import { render, staticRenderFns } from "./CouncilAreaList.vue?vue&type=template&id=3134fbee"
import script from "./CouncilAreaList.vue?vue&type=script&lang=js"
export * from "./CouncilAreaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports